__turbopack_context__.v({
  "checkboxWrapper": "PlatformNewsletterCheckbox-module__eTD92G__checkboxWrapper",
  "closeModalButton": "PlatformNewsletterCheckbox-module__eTD92G__closeModalButton",
});
